import React from "react";
import nosotros from "../assets/nosotros.jpg";

const About = () => {
	return (
		<section className="about" id="nosotros">
			<div className="container">
				<div className="about__inner">
					<div className="about__visual">
						<div className="about__img-wrapper">
							<img
								src={nosotros}
								alt="Nosotros"
								className="about__personaje"
							/>
						</div>
					</div>

					<div className="about__content">
						<span className="section-tag">our story</span>
						<h2 className="section-title">
							not your average{" "}
							<span className="text-accent">coffee shop</span>
						</h2>
						<p className="about__text">
							dossis nació de dos hermanas con una obsesión sana
							(o no tan sana) por el café. queríamos un lugar
							donde tomarte un latte se sintiera como un ritual y
							donde cada bebida tuviera personalidad propia.
						</p>
						<p className="about__text">
							trabajamos con granos de especialidad, leches
							alternativas, cold foams hechos en casa y
							combinaciones que probablemente no habías visto.
							nada aquí es accidental, todo está diseñado para que
							vuelvas.
						</p>
						<div className="about__stats">
							<div className="about__stat">
								<span className="about__stat-number">+8</span>
								<span className="about__stat-label">
									jarabes
								</span>
							</div>
							<div className="about__stat">
								<span className="about__stat-number">+30</span>
								<span className="about__stat-label">
									bebidas
								</span>
							</div>
							<div className="about__stat">
								<span className="about__stat-number">∞</span>
								<span className="about__stat-label">
									combinaciones posibles
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default About;
